import React from 'react';

import CommonImage from '@/components/CommonImage';

const ProjectList = () => {
	return (
		<div className="task-configuration-container px-4 py-2">
			<div className="project-list-view-table mt-3">
				<table className="table with-border scroll-x-label">
					<thead>
						<tr>
							<th>Brand</th>
							<th>Project type</th>
							<th>Project name</th>
							<th>Owner</th>
							<th>Start date</th>
							<th>End date</th>
							<th>Buyer first selection date</th>
							<th>Satus</th>
							<th>Priority </th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="brand-column">Techpack creation</td>
							<td className="project-type-column">1</td>
							<td className="project-name-column">
								<p>Techpack creation</p>
							</td>
							<td className="owner-column">
								<p>Task</p>
							</td>
							<td className="start-date-column expired-date">
								<p>Task</p>
							</td>
							<td className="end-date-column expired-date">
								<p>Task</p>
							</td>
							<td className="buyer-date-column">
								<p>Task</p>
							</td>
							<td className="status-column">
								<span className="status gray-2">Not started</span>
								<span className="status yellow-3">Working on it</span>
								<span className="status green-3">Done</span>
								<div className="d-flex align-items-center justify-content-start">
									<div className="progress progress-square">
										<div className="progress-bar" style={{ width: '40%' }}></div>
									</div>
									<div className="progress-text ml-2">
										<p className="regular-14 gray_dark_01">4/10</p>
									</div>
								</div>
							</td>
							<td className="priority-column">
								<div className="option">
									<div className="dropdown">
										<button
											aria-expanded="false"
											className="btn btn-default dropdown-toggle"
											data-toggle="dropdown"
											id="menu1"
											type="button"
										>
											<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
										</button>
										<ul
											aria-labelledby="menu1"
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											x-placement="bottom-end"
										>
											<li className="px-4 pb-3 pt-3" role="presentation">
												<a
													className="font-weight-normal  text-black"
													href="/invoices/edit/10052"
													role="menuitem"
													tabIndex={-1}
												>
													Edit
												</a>
											</li>
											<li className="px-4 pb-3" role="presentation">
												<a
													className="font-weight-normal  text-black"
													href
													role="menuitem"
													tabIndex={-1}
												>
													Delete
												</a>
											</li>
										</ul>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ProjectList;
